import { ChangeDetectionStrategy, Component, model, output } from '@angular/core';
import { AbstractToggleFormComponent } from '@spike/scaffolds';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-abstract-toggle-side-panel',
  providers:[],
  imports: [CommonModule, FormsModule],
  template: ''
})
export abstract class AbstractToggleSidePanelComponent<T> extends AbstractToggleFormComponent<T>{
  isDialogVisible = model.required<boolean>();
  public readonly onSave = output<T>();
  public readonly onClose = output<void>();
  public readonly onDelete = output<void>();

}